import React from 'react';

export const steps = [
  {
    target: '#subscriptions-filter',
    content: 'Atualizamos nosso filtro de contratos para facilitar ainda mais a sua vida. Confira as novidades.',
  },
  {
    target: '#subscriptions-filter',
    content: 'Aqui você encontra os filtros mais utilizados no seu dia a dia.',
  },
  {
    target: '#advanced-filter-subscriptions-modal-button',
    content: 'Caso precise, você pode fazer configurações mais detalhadas em nosso filtro avançado.',
  },
  {
    target: '#my-subscriptions',
    content: (
      <span>
        Viu como é fácil filtrar seus contratos? Aproveite a novidade e caso tenha alguma dúvida entre em contato com nosso atendimento pelo e-mail
        <b> suporte@eduzz.com</b>
      </span>
    ),
  },
];
